import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import ModalViewCreative from '../../components/Campaign/WizardCreatives/UploadedCreatives/ModalViewCreative/ModalViewCreative';
import Loading from '../../components/Loading/Loading';
import { useService } from '../UseService';

const normalizeUrl = (url) => {
    try {
        return decodeURIComponent(url || '').trim();
    } catch (error) {
        return (url || '').trim();
    }
};

const getCreativeUrls = (creativeItem) =>
    [creativeItem?.url, creativeItem?.thumbnail_url, creativeItem?.remoteUrl].filter(
        Boolean
    );

function CreativityPublicView({}) {
    const service = useService();
    const location = useLocation();
    const query = new URLSearchParams(location.search);
    const campaignId = query.get('campaignid');
    const creativeUrl = query.get('url');
    const [creative, setCreative] = useState();
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        setIsLoading(true);
        service
            .getCreatives(campaignId)
            .then((creatives) => {
                const targetUrl = normalizeUrl(creativeUrl);
                const selectedCreative = targetUrl
                    ? creatives.find((creativeItem) =>
                          getCreativeUrls(creativeItem).some(
                              (url) => normalizeUrl(url) === targetUrl
                          )
                      )
                    : null;

                setCreative(selectedCreative || creatives[0]);
            })
            .finally(() => setIsLoading(false));
    }, [campaignId, creativeUrl]);
    const Background = `/${process.env.REACT_APP_WL_NAME}/images/cover-home.jpg`;

    return (
        <div className="w-full h-screen flex justify-between">
            <div
                className="w-full bg-cover bg-center"
                style={{ backgroundImage: 'url(' + Background + ')' }}>
                <img
                    src={
                        require(`../../images/${process.env.REACT_APP_WL_NAME}/logo-white.svg`)
                            .default
                    }
                    alt="logo"
                    className="h-28 mx-auto mt-4"
                />
                <Loading isLoading={isLoading} />
                {creative && (
                    <ModalViewCreative
                        creative={creative}
                        isActive={true}
                        isHandle={false}
                        size={'max-h-80'}
                    />
                )}
            </div>
        </div>
    );
}

export default CreativityPublicView;
